import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25 position-relative" }
const _hoisted_9 = {
  key: 0,
  class: "position-absolute w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-95",
  style: {"z-index":"1000","top":"0","left":"0","min-height":"100%","border-radius":"8px"}
}
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = {
  class: "accordion mb-4",
  id: "statisticsAccordion"
}
const _hoisted_19 = { class: "accordion-item" }
const _hoisted_20 = {
  class: "accordion-header",
  id: "statisticsHeader"
}
const _hoisted_21 = {
  id: "statisticsCollapse",
  class: "accordion-collapse collapse",
  "aria-labelledby": "statisticsHeader",
  "data-bs-parent": "#statisticsAccordion"
}
const _hoisted_22 = {
  class: "accordion-body",
  id: "statisticsContent"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "card" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "row text-center" }
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = { class: "border-end" }
const _hoisted_30 = { class: "text-success mb-1" }
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = { class: "text-danger mb-1" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "text-primary mb-1" }
const _hoisted_35 = { class: "table-responsive" }
const _hoisted_36 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_37 = {
  key: 1,
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_41 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_42 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_43 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_44 = { class: "shadow-none lh-1 fw-medium pe-0" }
const _hoisted_45 = {
  key: 0,
  class: "badge text-outline-danger"
}
const _hoisted_46 = {
  key: 1,
  class: "badge text-outline-primary"
}
const _hoisted_47 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_48 = { class: "dropdown" }
const _hoisted_49 = { class: "dropdown-menu" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddArrieresModal = _resolveComponent("AddArrieresModal")!
  const _component_VoirDetails = _resolveComponent("VoirDetails")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "d-flex align-items-center" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.telecharger && _ctx.telecharger(...args))),
                disabled: _ctx.isLoading,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                type: "button"
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1)),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Exporter"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("span", {
                        class: "spinner-grow spinner-grow-sm me-2",
                        role: "status",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Export en cours... ", -1)
                    ]))]))
              ], 8, _hoisted_4))
            : _createCommentVNode("", true),
          (!_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", _hoisted_7, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.isLoadingData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "text-center" }, [
                _createElementVNode("div", {
                  class: "spinner-border text-primary mb-3",
                  role: "status",
                  style: {"width":"3rem","height":"3rem"}
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                ]),
                _createElementVNode("h5", { class: "text-muted mb-2" }, "Chargement des données..."),
                _createElementVNode("p", { class: "text-muted small" }, "Veuillez patienter pendant que nous récupérons les informations.")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)),
                _createVNode(_component_Field, {
                  style: {"max-height":"42px"},
                  modelValue: _ctx.motCle,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.motCle) = $event)),
                  name: "mot",
                  type: "text",
                  disabled: _ctx.isLoadingData,
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Recherche par mot clé"
                }, null, 8, ["modelValue", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Secteur "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "secteur",
                  modelValue: _ctx.secteur,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.secteur) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.secteursOptions,
                      searchable: true,
                      disabled: _ctx.isLoadingData
                    }, field, { placeholder: "Sélectionner un secteur" }), null, 16, ["options", "disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "secteur",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " État ", -1)),
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.etatsSelectionnes,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.etatsSelectionnes) = $event)),
                  options: _ctx.etatsOptions,
                  searchable: true,
                  disabled: _ctx.isLoadingData,
                  placeholder: "Sélectionner les états"
                }, null, 8, ["modelValue", "options", "disabled"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h2", _hoisted_20, [
              _cache[14] || (_cache[14] = _createElementVNode("button", {
                class: "accordion-button collapsed",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#statisticsCollapse",
                "aria-expanded": "false",
                "aria-controls": "statisticsCollapse"
              }, [
                _createElementVNode("i", { class: "flaticon-chart me-2" }),
                _createTextVNode(" Statistiques sur les arrièrés ")
              ], -1)),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportStatisticsAsSVG && _ctx.exportStatisticsAsSVG(...args))),
                class: "btn btn-sm btn-outline-primary ms-2",
                title: "Exporter les statistiques en SVG"
              }, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("i", { class: "flaticon-download me-1" }, null, -1),
                _createTextVNode(" Export SVG ", -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"col-md-6\" data-v-26b322f5><div class=\"card\" data-v-26b322f5><div class=\"card-header\" data-v-26b322f5><h5 class=\"card-title mb-0\" data-v-26b322f5>Répartition des contrats</h5></div><div class=\"card-body\" data-v-26b322f5><canvas id=\"contratsChart\" width=\"400\" height=\"200\" data-v-26b322f5></canvas></div></div></div>", 1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-header" }, [
                        _createElementVNode("h5", { class: "card-title mb-0" }, "Résumé statistique")
                      ], -1)),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.sansArrieres || 0), 1),
                              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-muted mb-0" }, "Avec arriérés payés", -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.avecArrieres || 0), 1),
                            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-muted mb-0" }, "Avec arriérés impayés", -1))
                          ])
                        ]),
                        _cache[18] || (_cache[18] = _createElementVNode("hr", null, null, -1)),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("h4", _hoisted_34, _toDisplayString(_ctx.totalElements || 0), 1),
                          _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-muted mb-0" }, "Total des contrats avec arrièrés payés ou non payés", -1))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _cache[26] || (_cache[26] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_35, [
          (!_ctx.isLoadingData && _ctx.contratEmplacements.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("div", { class: "mb-3" }, [
                  _createElementVNode("i", {
                    class: "fas fa-search text-muted",
                    style: {"font-size":"3rem"}
                  })
                ], -1),
                _createElementVNode("h5", { class: "text-muted mb-2" }, "Aucune donnée trouvée", -1),
                _createElementVNode("p", { class: "text-muted" }, "Aucun contrat ne correspond à vos critères de recherche.", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("table", _hoisted_37, [
                _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Secteur "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Nouveau Code "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Locataire "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Exploitant "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Loyer "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Arriérés "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Statut "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, " Actions")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contratEmplacements, (contrat, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_38, _toDisplayString(contrat.libelle_secteur), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(contrat.ncode_emp), 1),
                      _createElementVNode("td", _hoisted_40, _toDisplayString((contrat.usagerLocataire)), 1),
                      _createElementVNode("td", _hoisted_41, _toDisplayString((contrat.exploitant)), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.formatWithThousandSeparator(contrat.loyer)), 1),
                      _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatWithThousandSeparator(contrat.too)), 1),
                      _createElementVNode("td", _hoisted_44, [
                        (contrat.etat == 0 || contrat.etat == null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, "En attente"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_46, "Validé"))
                      ]),
                      _createElementVNode("td", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _cache[24] || (_cache[24] = _createElementVNode("span", {
                            class: "badge text-white bg-primary fs-15 dropdown-toggle",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createTextVNode(" Actions "),
                            _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_49, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                type: "button",
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.ajoutArr(contrat.id)),
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#VoirDetails"
                              }, [...(_cache[22] || (_cache[22] = [
                                _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Consulter détails ", -1)
                              ]))], 8, _hoisted_50)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                type: "button",
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.ajoutArr(contrat.id)),
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddArrieresModal"
                              }, [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Modifier ", -1)
                              ]))], 8, _hoisted_51)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddArrieresModal, {
      item: _ctx.selectedItem,
      type: _ctx.typeT,
      onClose: _ctx.recharger,
      onOpenmodal: _ctx.show_Modal
    }, null, 8, ["item", "type", "onClose", "onOpenmodal"]),
    _createVNode(_component_VoirDetails, {
      item: _ctx.selectedItem,
      secteur: _ctx.secteur,
      onClose: _ctx.recharger,
      onOpenmodal: _ctx.show_Modal
    }, null, 8, ["item", "secteur", "onClose", "onOpenmodal"])
  ], 64))
}